import api from './api';

const BASE = '/cluster';

const clusterService = {
  // Clusters
  getClusters:    ()         => api.get(BASE).then(r => r.data),
  createCluster:  (data)     => api.post(BASE, data).then(r => r.data),
  updateCluster:  (id, data) => api.put(`${BASE}/${id}`, data).then(r => r.data),
  deleteCluster:  (id)       => api.delete(`${BASE}/${id}`).then(r => r.data),
  getSummary:     ()         => api.get(`${BASE}/summary`).then(r => r.data),
  seedMasterData: ()         => api.post(`${BASE}/seed`).then(r => r.data),

  // Division-Cluster Mappings
  getMappings:    ()         => api.get(`${BASE}/mapping`).then(r => r.data),
  createMapping:  (data)     => api.post(`${BASE}/mapping`, data).then(r => r.data),
  updateMapping:  (id, data) => api.put(`${BASE}/mapping/${id}`, data).then(r => r.data),
  deleteMapping:  (id)       => api.delete(`${BASE}/mapping/${id}`).then(r => r.data),

  // Cluster Heads
  getClusterHeads:    ()         => api.get(`${BASE}/head`).then(r => r.data),
  createClusterHead:  (data)     => api.post(`${BASE}/head`, data).then(r => r.data),
  updateClusterHead:  (id, data) => api.put(`${BASE}/head/${id}`, data).then(r => r.data),
  deleteClusterHead:  (id)       => api.delete(`${BASE}/head/${id}`).then(r => r.data),

  // Division Heads
  getDivisionHeads:    ()         => api.get(`${BASE}/division-head`).then(r => r.data),
  createDivisionHead:  (data)     => api.post(`${BASE}/division-head`, data).then(r => r.data),
  updateDivisionHead:  (id, data) => api.put(`${BASE}/division-head/${id}`, data).then(r => r.data),
  deleteDivisionHead:  (id)       => api.delete(`${BASE}/division-head/${id}`).then(r => r.data),

  // Division Aliases
  getAliases:    ()         => api.get(`${BASE}/alias`).then(r => r.data),
  createAlias:   (data)     => api.post(`${BASE}/alias`, data).then(r => r.data),
  updateAlias:   (id, data) => api.put(`${BASE}/alias/${id}`, data).then(r => r.data),
  deleteAlias:   (id)       => api.delete(`${BASE}/alias/${id}`).then(r => r.data),

  // Cluster dashboard pivot
  getClusterDashboard: (params = {}) =>
    api.get('/attrition-occupancy/cluster-dashboard', { params, timeout: 60000 }).then(r => r.data),

  // Drill-down: employees for a specific division × month cell
  clusterLossDrill: (division, monthKey) =>
    api.get('/attrition-occupancy/cluster-loss-drill', { params: { division, monthKey } }).then(r => r.data),
};

export default clusterService;
